import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { InnogyComponentRendering } from '@core/jss-models';
import { RoundedCurrencyPipe, UtilsModule } from '@innogy/utils-deprecated';
import { CommonUiUtilityComponentsModule } from '@legacy/common-ui-utility-components';
import { JssModule } from '@sitecore-jss/sitecore-jss-angular';

@Component({
  selector: 'ed-offer-overview-budget-bill[budgetBillAmount]',
  templateUrl: './offer-overview-budget-bill.component.html',
  styleUrls: ['./offer-overview-budget-bill.component.scss'],
  standalone: true,
  imports: [
    JssModule,
    CommonModule,
    CommonUiUtilityComponentsModule,
    UtilsModule,
  ],
  providers: [RoundedCurrencyPipe],
})
export class OfferOverviewBudgetBillComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: InnogyComponentRendering;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() budgetBillAmount!: number;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() cashback?: number;
}
